import { Medium } from '@energiebespaarders/symbols/helpers';
import {
  ChatAlertAlt,
  ClipboardCheck,
  FileEuro,
  Shield,
  WrenchScrewdriver,
} from '@energiebespaarders/symbols/icons/solid';
import { QuoteInfoAccordion } from '../utils';
import { debWarranty } from './constants';

export const insulationGlazingInfoAccordions = (
  needsPtc: boolean,
  needsPrepayment: boolean,
): QuoteInfoAccordion[] => [
  {
    key: 'feasibility',
    title: 'Technische haalbaarheid en volledigheid',
    paragraphs: [
      'De prijs is geldig voor de aangeboden specificatie van hoeveelheden en glassoorten. Afwijking heeft directe prijswijziging tot gevolg. Controleer daarom op juiste specificaties.',
    ],
    icon: ClipboardCheck,
    hide: !needsPtc,
  },
  {
    key: 'warranty',
    title: 'Installatiegarantie en service',
    paragraphs: [
      <h5 key="glazing-warranty-1">Productgarantie: 10 jaar</h5>,
      'Productgarantie houdt in dat de fabrikant garandeert dat het product voldoet aan de door de fabrikant gestelde verwachtingen. Een fabrikant verbindt vaak een termijn aan de garantie, van bijvoorbeeld enkele maanden of jaren. Zo wordt bijvoorbeeld voorkomen dat jij of de installateur de dupe wordt van een fabricagefout.',
      <h5 key="glazing-warranty-2">Installatiegarantie: 10 jaar</h5>,
      'Onze glaszetter monteert volgens de modernste richtlijnen en voorschriften. Onze installateur zal het glas, de kozijnen en ramen op de juiste wijze te monteren (deugdelijke installatie conform de algemene voorwaarden. Mochten er toch gebreken zijn die vanaf de oplevering al aanwezig waren dan verbindt de glaszetter zich eraan om deze, binnen een redelijke termijn na het vaststellen van dit gebrek, kosteloos te herstellen.',
      debWarranty,
    ],
    icon: Shield,
  },
  {
    key: 'invoicing',
    title: 'Facturatie',
    paragraphs: [
      ...(needsPrepayment
        ? [
            <p key="glazing-invoicing-0">
              <Medium>Aanbetaling:</Medium> 25% van het totale offertebedrag wordt na het accepteren
              van de definitieve offerte {needsPtc ? '(dus na de technische controle) ' : ''}in
              rekening gebracht.
            </p>,
            <p key="hybrid-invoicing-1">
              <Medium>Facturatie:</Medium> 75% van het totale offertebedrag na oplevering.
            </p>,
          ]
        : [
            <p key="hybrid-invoicing-1">
              <Medium>Facturatie:</Medium> het totale offertebedrag na oplevering.
            </p>,
          ]),
      <p key="glazing-invoicing-2">
        <Medium>Betalingstermijn:</Medium> binnen 7 dagen na factuurdatum.
      </p>,
      <p key="glazing-invoicing-3">
        <Medium>Uitvoering:</Medium> in overleg, na ontvangst opdracht. Als u de opdracht wilt
        annuleren, zijn hier mogelijk kosten aan verbonden.
      </p>,
    ],
    icon: FileEuro,
  },

  {
    key: 'activities',
    title: 'Montage en coördinatie',
    paragraphs: [
      'De werkzaamheden bij het installeren van isolatieglas omvatten in hoofdzaak:',
      <ul key="glazing-activities-1">
        <li>Bestaande latten demonteren en afvoeren (hergebruik indien vermeld);</li>
        <li>Bestaand glas demonteren en afvoeren;</li>
        <li>Afvoeren van het oude glas;</li>
        <li>Schoonmaken sponningen;</li>
        <li>
          Montage van nieuw glas:
          <ul>
            <li>1 x voorgronden sponningen met sneldrogende witte grondverf;</li>
            <li>Het plaatsen van nieuw glas met indien vermeld nieuwe glaslatten;</li>
            <li>
              Het plaatsen van balansveren en/of contragewichten (indien vermeld in de offerte)
            </li>
            <li>Het aanbrengen van kierdichting (indien vermeld in de offerte);</li>
          </ul>
        </li>
        <li>Voorzieningen, e.g. kosten voor steigers (indien vermeld in de offerte).</li>
      </ul>,
      'De volgende werkzaamheden zijn in onze offerte opgenomen:',
      <ul key="glazing-activities-2">
        <li>Voorrijkosten;</li>
        <li>Parkeerkosten;</li>
        <li>De kosten voor het opmeten van de productiematen;</li>
        <li>De kosten voor klein materiaal (o.a. kit, RVS spijkers, schroeven);</li>
        <li>De kosten voor hang- en sluitwerk.</li>
      </ul>,
      <p key="glazing-activities-3">
        Indien niet anders vermeld, zijn de volgende werkzaamheden{' '}
        <Medium>niet in deze offerte opgenomen</Medium>:
      </p>,
      <ul key="glazing-activities-4">
        <li>Montage en afhalen werkplaats;</li>
        <li>Timmerwerkzaamheden;</li>
        <li>Houtrotherstel of signaleren ervan;</li>
        <li>Gebruik van steigers, kraanhulp en verticale transportmiddelen;</li>
        <li>Overige bouwkundige werkzaamheden.</li>
      </ul>,
    ],
    icon: WrenchScrewdriver,
  },
  {
    key: 'reminders',
    title: 'Let ook hierop',
    paragraphs: [
      'Er zijn een aantal aandachtspuntjes voor u als bewoner om de uitvoer zo soepel mogelijk te laten verlopen:',
      <ul key="glazing-reminders-1">
        <li>
          Zorg ervoor er ongeveer 1m<sup>2</sup> rondom het raam vrij is voor de glaszetter om te
          werken;
        </li>
      </ul>,
    ],
    icon: ChatAlertAlt,
  },
];
